import { render, staticRenderFns } from "./AgendadasPeriodo.vue?vue&type=template&id=59854aac"
import script from "./AgendadasPeriodo.vue?vue&type=script&lang=js"
export * from "./AgendadasPeriodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports